import PropTypes from "prop-types"

import Image from "components/ui/image"
import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"

const ProductPrice = ({ product }) => {
  const onSale = product.reg !== product.selling

  return (
    <div className="flex items-center justify-center">
      {false && product.quickShip && (
        <Image
          className="mr-8"
          height="881"
          src={require("images/icons/quick_ship_green.svg")}
          style={{ width: "20px" }}
          width="922"
        />
      )}
      <p className="text-12 leading-14 text-black">
        {IS_JEWLR() ? (
          <>
            from{" "}
            {onSale ? (
              <>
                (<strike>{to_currency(product.reg, { precision: 0 })}</strike>){" "}
                <span
                  className="text-sale"
                  data-cy={`collection-product-price-${product.style_code}`}
                >
                  {to_currency(product.selling, { precision: 0 })}
                </span>
              </>
            ) : (
              to_currency(product.reg, { precision: 0 })
            )}
          </>
        ) : (
          <span
            className="text-sale"
            data-cy={`collection-product-price-${product.style_code}`}
          >
            {to_currency(product.selling, { precision: 0 })}
          </span>
        )}
      </p>
    </div>
  )
}

ProductPrice.propTypes = {
  product: PropTypes.object,
}

export default ProductPrice
